import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SectorState {
  editId: number | null
  isCreateModalOpen: boolean
}

const initialState: SectorState = {
  editId: null,
  isCreateModalOpen: false
}

const sectorSlice = createSlice({
  name: 'sector',
  initialState,
  reducers: {
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    }
  }
})

export const sectorActions = sectorSlice.actions
export const { reducer: sectorReducer } = sectorSlice
